//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { insureApplyQuery, getInsuranceAndCompanyList } from '@/api/credit';
import { getChilComList, getCompanyList } from '@/api/baseDate';
import { delData } from '@/api/apis';
export default {
  name: 'CustomInsureApplyQuery',
  filters: {
    protoStatus: function protoStatus(value) {
      if (value == '1') return '暂存';else if (value == '2') return '修改中';else if (value == '3') return '已提交';else if (value == '4') return '保险公司未承保';else if (value == '5') return '保单生效';
    }
  },
  data: function data() {
    return {
      notUnderWriteReason: '',
      userType: '',
      selectedArr: [],
      lists: {
        proposalNo: '',
        protocolNo: '',
        documentType: ''
      },
      agentPrintShow: false,
      newList: [],
      props: {
        label: 'label',
        value: 'value'
      },
      currentPage4: 4,
      loading: true,
      restaurants: [],
      timeout: null,
      tableData: {
        content: [],
        pageNum: 0,
        pageSize: 0,
        pages: 0,
        startRow: 0,
        totalCount: 0
      },
      permissionsbtn: true,
      value: '',
      agentOptions: [],
      tableData1: [{
        applicationNo: '',
        applicationNoStatus: '投保单状态',
        riskCode: '险种代码',
        riskName: '险种名称',
        insuranceCompanyName: '保险公司',
        companyCode: '分支机构代码',
        companyName: '分支机构名称名称',
        applicantName: '投保人名称',
        expectStartDate: '起保日期'
      }],
      applicationStatusList: [{
        codeCode: '',
        codeName: '全部'
      }, {
        codeCode: '1',
        codeName: '暂存'
      }, {
        codeCode: '2',
        codeName: '修改中'
      }, {
        codeCode: '3',
        codeName: '已提交'
      }, {
        codeCode: '4',
        codeName: '保险公司未承保'
      }, {
        codeCode: '5',
        codeName: '保单生效'
      }],
      options: [{
        value: '666666',
        label: '人民保险'
      }],
      options1: [{
        value: '1',
        label: '上海分公司'
      }],
      options2: [],
      options3: [{
        value: '1',
        label: '是'
      }],
      insuranceList: [],
      inForm: {
        pageNo: 1,
        pageSize: 10,
        applicationNo: '',
        insuranceCompanyCode: '',
        companyCode: '',
        applicationStatus: '',
        expectStartDate: '',
        expectEndDate: '',
        policyNo: '',
        submitStartDate: '',
        submitEndDate: ''
      },
      pageNo: 1,
      // 第几页
      pageSize: 10,
      // 每页数量
      total: 0,
      // 总条数
      rules: {
        insuranceCompanyCode: [{
          required: false,
          message: '请选择保险公司',
          trigger: 'change'
        }],
        companyCode: [{
          required: false,
          message: '请选择分支机构',
          trigger: 'change'
        }],
        proposalStatus: [{
          required: false,
          message: '请选择保单状态',
          trigger: 'change'
        }]
      },
      options_insuranceCompanyName: [],
      options_companyName: []
    };
  },
  watch: {
    '$route': 'getPath' // 当路由发生变化时执行此函数

  },
  mounted: function mounted() {},
  created: function created() {
    this.userType = this.$store.state.user.userinfo.userType;
    this.initPage(); // this.Init_get()
    // console.log("页面protocol-search.vue")
    // const list = this.$store.state.user.userinfo.insuranceCompanyList || []
    // const companyCode = this.$store.state.user.userinfo.insuranceCompanyCode || ''
    //
    // this.get_select(list, companyCode)
    //
    // // 默认第一个保险公司
    // this.inForm.insuranceCompanyCode = this.options_insuranceCompanyName[0].value
    // this.inForm.insuranceCompanyName = this.options_insuranceCompanyName[0].label
    //
    // this.restaurants = this.loadAll()
  },
  methods: {
    initPage: function initPage() {
      var _this = this;

      var params = this.inForm;
      this.loading = true;
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      insureApplyQuery(params).then(function (res) {
        _this.tableData = res;
        _this.loading = false;
      });
      getInsuranceAndCompanyList().then(function (res) {
        // 默认第一个保险公司
        _this.options_insuranceCompanyName = [];

        for (var i = 0; i < res.insuranceList.length; i++) {
          console.log(res);
          var obj = {};
          obj.value = res.insuranceList[i].insuranceCompanyCode;
          obj.label = res.insuranceList[i].insuranceCompanyName;

          if (!obj.value || !obj.label) {
            _this.options_insuranceCompanyName = [];
          } else {
            _this.options_insuranceCompanyName.push(obj);
          }
        }
      });
    },
    delRow: function delRow(row) {
      var _this2 = this;

      console.log('row--单号', row.applicationNo);
      delData({
        applicationNo: row.applicationNo
      }).then(function (res) {
        if (res.rtnCode == '0000') {
          _this2.$message({
            type: 'success',
            message: '删除成功'
          });

          _this2.initPage();
        } else {
          _this2.$message({
            type: 'error',
            message: '删除失败'
          });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    // 查看 修改2
    submit: function submit(type, data) {
      console.log('type==', type);
      console.log('data==', data);

      if (type == 'view') {
        this.$router.push({
          path: "/creditInsure/viewPolicy/".concat(type, "/").concat(data.applicationNo)
        });
      } else if (type == 'edit') {
        this.$router.push({
          path: "/creditInsure/editPolicy/".concat(type, "/").concat(data.applicationNo)
        });
      } //
      // const orgCode =JSON.parse(sessionStorage.getItem('neworgCode'))
      // console.log(orgCode)
      // console.log(data.row.user_type)
      // console.log(this.$store.state.user.userinfo.userType)

    },
    underWrite: function underWrite(type, data) {
      console.log(type);
      console.log(data);
      console.log(1234);
      this.agentPrintShow = true;
    },
    getPath: function getPath() {
      this.Init_get();
    },
    cancel: function cancel() {
      this.agentPrintShow = false;
    },
    confirm: function confirm() {
      var _this3 = this;

      this.$refs['agentPrint'].validate(function (valid) {
        if (valid) {
          _this3.agentPrintShow = false;

          if (_this3.agentPrintTitle === '电子保单') {
            setTimeout(_this3.doPolicyTimer('1'), 20000);

            _this3.get_data(1);
          } else if (_this3.agentPrintTitle === 'CI凭证') {
            setTimeout(_this3.doPolicyTimer('2'), 20000);

            _this3.get_data(2);
          }

          _this3.$refs['agentPrint'].resetFields();
        }
      });
    },
    // 初始化
    Init_get: function Init_get() {
      var _this4 = this;

      var params = this.inForm;
      this.loading = true;
      params.pageNo = this.pageNo;
      params.pageSize = this.pageSize;
      insureApplyQuery(params).then(function (res) {
        _this4.tableData = res;
        _this4.loading = false;
      });
    },
    // 每页条数
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.Init_get();
    },
    // 当前页码
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageNo = val;
      this.Init_get();
    },
    // 查询
    search_s: function search_s(formName) {
      var _this5 = this;

      //  去除首尾空格
      var data = {};

      if (this.inForm.submitStartDate && this.inForm.submitEndDate) {
        if (this.inForm.submitStartDate > this.inForm.submitEndDate) {
          this.$message({
            type: 'warning',
            message: '申请提交日期起不能晚于申请提交日期止'
          });
          return false;
        }
      } //  去除首尾空格


      if (this.inForm.expectStartDate && this.inForm.expectEndDate) {
        if (this.inForm.expectStartDate > this.inForm.expectEndDate) {
          this.$message({
            type: 'warning',
            message: '起保起期不能晚于起保止期'
          });
          return false;
        }
      }

      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this5.pageNo = 1;

          _this5.Init_get();
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 重置
    search_s_clear: function search_s_clear() {
      this.inForm = {
        pageNo: 1,
        pageSize: 10,
        applicationNo: '',
        insuranceCompanyCode: '',
        companyCode: '',
        applicationStatus: '',
        expectStartDate: '',
        expectEndDate: '',
        policyNo: '',
        submitStartDate: '',
        submitEndDate: ''
      }; // //清空分支机构

      this.options_companyName = [];
      this.options2 = [];
    },
    // 删除
    del_but: function del_but(row) {
      var _this6 = this;

      this.$confirm('此操作将永久删除该申请单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var data = {
          applicationNo: row.row.applicationNo
        };
        deleteByProposalNo_fun(data).then(function (res) {
          if (res.rtnCode == '0000') {
            _this6.$message({
              message: '删除成功',
              type: 'success'
            });

            _this6.Init_get();
          }
        });
      }).catch(function () {
        _this6.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
      console.log(row); //				this.tableData.splice(row.$index, 1)
    },
    // 支持模糊查询
    loadAll: function loadAll() {
      return [{
        'value': '三全鲜食（北新泾店）',
        'address': '长宁区新渔路144号'
      }, {
        'value': 'Hot honey 首尔炸鸡（仙霞路）',
        'address': '上海市长宁区淞虹路661号'
      }, {
        'value': '新旺角茶餐厅',
        'address': '上海市普陀区真北路988号创邑金沙谷6号楼113'
      }];
    },
    querySearchAsync: function querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter: function createStateFilter(queryString) {
      return function (state) {
        return state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    handleSelect: function handleSelect(item) {
      console.log(item);
    },
    // 查看 ------ 编辑
    view_but: function view_but(type, row) {
      console.log(row);
      var params = {
        type: type,
        insurancecompanyCode: row.row.insuranceCompanyCode,
        protocolNo: row.row.protocolNo,
        riskCode: row.row.riskCode,
        riskName: row.row.riskName,
        proposalNo: row.row.proposalNo
      };
      console.log(params.insurancecompanyCode);
      /*this.$router.push({
         path: `/policymanagement/insuranceentry/${params.type}/${params.insurancecompanyCode}/${params.protocolNo}/${params.riskCode}/${params.riskName}/${params.proposalNo}`
      })*/

      console.log(type);

      if (type == 'opcopy') {
        //无报关单
        this.$router.push({
          name: 'insuranceentry1',
          params: params
        });
      } else {
        if (row.row.othFlag != undefined && 'customFlag' == row.row.othFlag) {
          //报关单
          this.$router.push({
            name: 'insuranceentry2',
            params: params
          });
        } else if (row.row.othFlag != undefined && 'autoCustomFlag' == row.row.othFlag) {
          //报关单自动投保
          this.$router.push({
            name: 'insuranceentry3',
            params: params
          });
        } else {
          //无报关单
          this.$router.push({
            name: 'insuranceentry1',
            params: params
          });
        }
      }
    },
    // 保险公司
    insuranceCompanyCode_ch: function insuranceCompanyCode_ch(val) {
      console.log(val);
      var obj = {};
      obj = this.options_insuranceCompanyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.insuranceCompanyName = obj.label; // 查询保险公司下的分支机构

      this.companyqueryAll_fun(val);
    },
    // 分支机构
    companyCode_ch: function companyCode_ch(val) {
      var obj = {};
      obj = this.options_companyName.find(function (item) {
        // 这里的userList就是上面遍历的数据源
        return item.value === val; // 筛选出匹配数据
      });
      this.inForm.companyName = obj.label;
    },
    // 新增
    add_but: function add_but(type) {
      // this.$router.push({
      // 	name: 'policyentry',
      // 	params: {
      // 		type: type,
      // 		proposalNo: ''
      // 	}
      // });
      this.$router.push({
        path: "/creditInsure/inputPolicy"
      });
    },
    // 保险公司
    findInsuranceCompany_fun: function findInsuranceCompany_fun(list) {
      var _this7 = this;

      //				var plk = {
      //					label:"请选择",
      //					value:""
      //
      //				}
      this.options_insuranceCompanyName = [];

      for (var i = 0; i < list.length; i++) {
        var obj = {};
        obj.value = list[i].insuranceCompanyCode;
        obj.label = list[i].insuranceCompanyName;

        if (!obj.value || !obj.label) {
          this.options_insuranceCompanyName = [];
        } else {
          this.options_insuranceCompanyName.push(obj);
        }
      }

      var data = {
        insuranceCompanyCode: code
      };
      getCompanyList(data).then(function (res) {
        _this7.options_insuranceCompanyName = [];

        for (var i = 0; i < res.length; i++) {
          console.log(res);
          var obj = {};
          obj.value = res[i].insuranceCompanyCode;
          obj.label = res[i].insuranceCompanyName;

          if (!obj.value || !obj.label) {
            _this7.options_insuranceCompanyName = [];
          } else {
            _this7.options_insuranceCompanyName.push(obj);
          }
        }
      });
    },
    // 分支机构
    companyqueryAll_fun: function companyqueryAll_fun(code) {
      var _this8 = this;

      this.options_companyName = [];
      var data = {
        insuranceCompanyCode: code
      };
      getChilComList(data).then(function (res) {
        for (var i = 0; i < res.length; i++) {
          var obj = {};
          obj.value = res[i].companyCode;
          obj.label = res[i].companyName;

          _this8.options_companyName.push(obj);
        }
      });
    }
  }
};